const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-content-block-carousel'] = {
        c: () => require('partner/modules/dobbies-content-block-carousel/dobbies-content-block-carousel.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-content-block-carousel',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-content-block-carousel'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-content-block-carousel|dobbies-content-block-carousel'] = {
                c: () => require('partner/modules/dobbies-content-block-carousel/dobbies-content-block-carousel.view.tsx'),
                cn: '__local__-__local__-dobbies-content-block-carousel'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };